/* This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */

import type { CoordinateMapper } from "./CoordinateMapper";

export class TouchState {
  handleTouchEvent(
    event: TouchEvent,
    coordinateMapper: CoordinateMapper,
    sendMessage: (message: string) => void,
  ): void {
    const messageType = "m";
    const leftMouseButton = 1;
    let buttonMask = 0;

    // Simulate left mouse button for touch
    if (event.type === "touchstart") {
      buttonMask = leftMouseButton;
    } else if (event.type === "touchmove") {
      event.preventDefault();
    }

    // Use first touch point
    const touch = event.changedTouches[0];
    const coords = coordinateMapper.clientToVideo(touch.clientX, touch.clientY);

    const message = `${messageType},${coords.x},${coords.y},${buttonMask},0`;
    sendMessage(message);
  }
}
